<template>
  <div v-if="cart.room">
    <div class="payment-sidebar font-bai">
      <div class="image-fit" v-if="cart.room.ImageIds && cart.room.ImageIds[0]">
        <img :src="getImageUri(cart.room.ImageIds[0])" alt />
      </div>
      <div class="paysidebar-info">
        <div class="paysidebar-product relative-section">
          <h3>
            <b>{{ getTranslate(cart.room.Name) }}</b>
          </h3>
          <h3 v-if="cart.room.camping">{{ cart.room.camping.name }}</h3>
          <p>
            {{ cart.info.adult }} {{ $t("app.Adultes") }}
            {{
              `${
                cart.info.child ? `, ${cart.info.child} ${$t("app.child")}` : ""
              }`
            }}
            {{
              `${
                cart.info.child1
                  ? `, ${cart.info.child1} ${$t("app.bébé")}`
                  : ""
              }`
            }}
          </p>
          <p>{{ getRoomBookTime() }}</p>
          <p>
            {{ $t("app.Date d’arrivée") }} :
            <b>{{ formatStartDate() }}</b>
          </p>
          <p>
            {{ $t("app.Date de départ") }}:
            <b>{{ formatEndDate() }}</b>
          </p>
          <div class="cart-links">
            <router-link to="/result" class="modifier-payment font-bold">{{
              $t("app.Modifier")
            }}</router-link>
            <a
              href
              class="remove-payment font-bold"
              @click.prevent="onClearCart"
              >{{ $t("app.Supprimer") }}</a
            >
          </div>
        </div>
        <div class="paysidebar-fee">
          <table class="payfee-table">
            <tr>
              <td>{{ getTranslate(cart.room.Name) }}</td>
              <td>
                {{ getPriceRoom(cart.room) }}
                {{ currency.symbol }}
              </td>
            </tr>
            <tr v-if="promotion">
              <td>
                {{
                  promotion.name
                    ? promotion.name
                    : $t("app.Offre promotionnelle")
                }}
              </td>
              <td>-{{ getPromotionValue() }} {{ currency.symbol }}</td>
            </tr>
            <!-- <tr>
              <td>{{ $t("app.Taxes de séjour") }}</td>
              <td>0,00 {{ currency.symbol }}</td>
            </tr> -->
            <tr class="font-bold subtotal">
              <td>{{ $t("app.Total de l’hébergement") }}</td>
              <td>{{ subtotal }} {{ currency.symbol }}</td>
            </tr>
            <tr v-for="(service, index) in cartProducts" :key="index">
              <td>
                {{ getTranslate(service.Name) }}
                <!-- <b v-if="totalPersons > 0">x {{totalPersons}}</b> -->
              </td>
              <td v-if="getServicePrice(service) > 0">
                {{ getServicePrice(service) }}
                {{ currency.symbol }}
              </td>
              <td v-if="getServicePrice(service) === 0">
                {{ $t("app.offert") }}
              </td>
            </tr>
            <tr class="font-bold" v-if="cartProducts.length">
              <td>{{ $t("app.Total Services") }}</td>
              <td>{{ totalService }} {{ currency.symbol }}</td>
            </tr>
          </table>
        </div>
        <div class="promotions relative-section" v-if="!promotion">
          <input
            type="text"
            name="voucher"
            v-model="voucher"
            id
            class="form-control"
            :placeholder="$t('app.Code Promo')"
          />
          <button
            type="button"
            :disabled="!voucher"
            @click.prevent="onValidateVoucher()"
            class="btn promo-appy"
          >
            {{ $t("app.Valider") }}
          </button>
        </div>
      </div>
      <div class="paysidebar-total">
        <span class="font-bold">
          {{ $t("app.Total") }}
        </span>
        <div class="total-right">
          <span class="total-price font-balo font-bold"
            >{{ total }} {{ currency.symbol }}</span
          >
          <span class="total-tax-text">{{
            $t("app.Taxe de séjour incluse")
          }}</span>
        </div>
      </div>
      <button
        class="btn btn-payment font-bold"
        type="submit"
        :disabled="isSubmitting"
        @click.prevent="onSetNextStep()"
      >
        {{ $t("app.étape suivante") }}
      </button>
    </div>
    <div class="payment-inclus" v-if="includeServices.length">
      <div class="inclus-more">
        <h3 class="font-bai text-uppercase font-bold">
          {{ $t("app.Inclus") }} :
        </h3>
        <ul class="list-inline font-bai font-bold">
          <li
            class="item-inline"
            v-for="(item, index) in includeServices"
            :key="index"
          >
            <img :src="item.icon" v-if="item.icon" alt />
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { get, filter, map, first, sumBy, round } from "lodash";
import moment from "moment";
import { CDN_MEWS_MEDIA } from "@/api/config";
import {
  numberOfNightsBetweenDates,
  formatBookDate
} from "@/helper/calculateDays";

export default {
  name: "CartSidebar",
  props: ["submitPaymentForm"],
  data() {
    return {
      voucher: "",
      includeServices: [],
      totalService: 0,
      subtotal: 0,
      totalDate: 0,
      totalPersons: 0,
      total: 0,
      promotion: null,
      isSubmitting: false
    };
  },
  mounted() {
    this.includeServices = filter(
      get(this.cart, "room.info.services", []),
      item => item.inclus
    );
    this.promotion = this.cart.promotion;
    this.voucher = this.cart.voucher || "";
    this.totalPersons = this.getTotalPersons();
    this.total = this.getTotalPrice();
    this.totalDate = this.getTotalDate();
    this.subtotal = this.getSubTotal();
    this.totalService = this.getTotalServices();

    if (this.step === "step1") {
      this.onGetPricing();
      this.onGetAvailabilityWithoutVoucher();
    }
  },
  computed: {
    ...mapState({
      cart: state => get(state, "cart.cart"),
      cartProducts: state => get(state, "cart.cart.products", []),
      lang: state => get(state, "app.lang", "fr"),
      filter: state => get(state, "hotels.filter", {}),
      currency: state => get(state, "app.currency"),
      step: state => get(state, "cart.step", "step1")
    })
  },
  methods: {
    ...mapActions("cart", [
      "getPricing",
      "validateVoucher",
      "setStep",
      "clearCart",
      "getAvailability",
      "setIsSubmitting"
    ]),
    getImageUri(image) {
      return `${CDN_MEWS_MEDIA}/Image/${image}?Mode=Fit&Height=161`;
    },
    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    formatStartDate() {
      return moment(this.filter.dateFrom).format("D MMM");
    },
    formatEndDate() {
      return moment(this.filter.dateTo).format("D MMM");
    },
    onValidateVoucher() {
      this.validateVoucher(this.voucher).then(({ IsValid }) => {
        if (!IsValid) {
          this.$bvToast.toast(
            this.$i18n.t("app.Your code promo is not valid"),
            {
              title: this.$i18n.t("app.Voucher"),
              variant: "danger",
              solid: true
            }
          );
        }
        this.onGetPricing();
      });
    },
    getPriceRoom(room) {
      const roomOccupancyAvailabilities = first(
        room.RoomOccupancyAvailabilities
      );
      const roomPrice = get(
        roomOccupancyAvailabilities,
        `Pricing.0.Price.TotalAmount.${this.currency.code}.GrossValue`
      );
      return roomPrice;
    },
    onGetPricing() {
      const child = this.cart.info.child || 0;
      const child1 = this.cart.info.child1 || 0;
      const dataPricing = {
        StartUtc: formatBookDate(this.cart.info.dateFrom),
        EndUtc: formatBookDate(this.cart.info.dateTo),
        RoomCategoryId: this.cart.room.RoomCategoryId,
        Occupancies: [
          {
            AdultCount: this.cart.info.adult || 0,
            ChildCount: child + child1 || 0
          }
        ]
      };
      if (this.voucher) {
        dataPricing.VoucherCode = this.voucher;
      }
      if (this.cart.products && this.cart.products.length) {
        dataPricing.ProductIds = map(this.cart.products, product => product.Id);
      }
      this.getPricing(dataPricing);
    },
    getTotalPrice() {
      const occupancyPrices = first(this.cart.occupancyPrices);
      const pricingObject = first(get(occupancyPrices, "Pricing", []));
      const totalPrice = get(
        pricingObject,
        `Price.TotalAmount.${this.currency.code}.GrossValue`
      );
      return totalPrice || 0;
    },
    onSetNextStep() {
      let nextStep = "step2";
      switch (this.step) {
        case "step1":
          nextStep = "step2";
          this.setStep(nextStep);
          break;
        case "step2":
          if (!this.isSubmitting) {
            this.isSubmitting = true;
            this.submitPaymentForm();
            setTimeout(() => {
              this.isSubmitting = false;
            }, 4000);
          }
          break;
        default:
          break;
      }
    },
    getRoomBookTime() {
      if (this.totalDate > 1) {
        return `${this.totalDate} ${this.$i18n.t("app.nuits")}`;
      } else {
        return `${this.totalDate} ${this.$i18n.t("app.nuit")}`;
      }
    },
    getServicePrice(item) {
      return round(
        get(item, `Prices.${this.currency.code}`) *
          this.totalPersons *
          this.totalDate,
        2
      );
    },
    getTotalServices() {
      const totalService = sumBy(this.cartProducts, item => {
        return get(item, `Prices.${this.currency.code}`);
      });

      return round(totalService * this.totalPersons * this.totalDate, 2);
      // const occupancyPrices = first(this.cart.occupancyPrices);
      // const pricingObject = first(get(occupancyPrices, "Pricing", []));
      // const totalPrice = get(
      //   pricingObject,
      //   `Price.TotalAmount.${this.currency.code}.GrossValue`
      // );
      // return round(totalPrice - this.subtotal, 2);
    },
    getSubTotal() {
      const roomOccupancyAvailabilities = first(
        this.cart.room.RoomOccupancyAvailabilities
      );
      const roomPrice = get(
        roomOccupancyAvailabilities,
        `Pricing.0.Price.TotalAmount.${this.currency.code}.GrossValue`
      );
      const promotionPrice = this.getPromotionValue() || 0;
      return round(roomPrice - promotionPrice, 2);
    },
    getTotalPersons() {
      const child = this.cart.info.child || 0;
      const child1 = this.cart.info.child1 || 0;
      const adult = this.cart.info.adult || 0;
      const totalPersons = child + child1 + adult;
      return totalPersons;
    },
    getTotalDate() {
      return numberOfNightsBetweenDates(
        moment(this.cart.info.dateFrom),
        moment(this.cart.info.dateTo)
      );
    },
    onClearCart() {
      this.clearCart();
      this.$router.push("result");
    },
    getPromotionValue() {
      const roomOccupancyAvailabilities = first(
        this.cart.room.RoomOccupancyAvailabilities
      );
      const roomPrice = get(
        roomOccupancyAvailabilities,
        `Pricing.0.Price.TotalAmount.${this.currency.code}.GrossValue`
      );
      const promotionValue = this.promotion ? this.promotion.value : 0;
      return round((roomPrice * promotionValue) / 100, 2);
    },
    onGetAvailabilityWithoutVoucher() {
      const dataReferences = this.filter;
      const data = {
        StartUtc: formatBookDate(dataReferences.dateFrom),
        EndUtc: formatBookDate(dataReferences.dateTo),
        AdultCount: dataReferences.adult,
        ChildCount:
          Number(dataReferences.child) + Number(dataReferences.child1),
        CategoryIds: [this.cart.room.Id]
      };
      this.getAvailability(data)
        .then(() => {})
        .catch(e => {
          if (!get(e, "Message")) return;
          this.$bvToast.toast(get(e, "Message", ""), {
            title: `Error`,
            variant: "danger",
            solid: true
          });
          return;
        });
    }
  },
  watch: {
    cart: function(value) {
      if (value.voucher !== this.voucher) {
        this.voucher = value.voucher;
      }
      this.totalDate = this.getTotalDate();
      this.totalPersons = this.getTotalPersons();
      this.subtotal = this.getSubTotal();
      this.totalService = this.getTotalServices();
      this.total = this.getTotalPrice();
    },
    currency: function() {
      this.subtotal = this.getSubTotal();
      this.totalService = this.getTotalServices();
      this.total = this.getTotalPrice();
    }
  }
};
</script>
